import { useCallback, useMemo } from "react";
import { useLazyGetRelationTypesQuery } from "./relationTypeApi";

export default function useRelationTypeField() {
  const [loadRelationTypes, { data, isFetching, isError }] = useLazyGetRelationTypesQuery();
  const options = useMemo(() => {
    const types = new Set((data?.data || [])
      .filter((row) => row?.relation_type)
      .map((row) => row.relation_type.toUpperCase()));
    return [...types].map((type) => ({ value: type, label: type }));
  }, [data]);

  const loadOptions = useCallback(() => {
    loadRelationTypes({ page: 1, limit: 1000 });
  }, [loadRelationTypes]);

  const field = useMemo(() => ({
    name: "relation_type",
    label: "Relation Type",
    type: "select",
    options: (formData, editData) => {
      const existing = editData?.relation_type;
      const available = existing && !options.some((option) => option.value === existing)
        ? [...options, { value: existing, label: existing }]
        : options;
      return formData.relation_type ? [{ value: "", label: "None" }, ...available] : available;
    },
    placeholder: isFetching
      ? "Loading relation types..."
      : isError || (data?.status === "failed" && data?.message !== "No Record Found")
      ? "Unable to load relation types — reopen form to retry"
      : options.length ? "Select relation type" : "No relation types found",
    disabled: isFetching,
  }), [data, isError, isFetching, options]);

  return { field, loadOptions };
}
